// extracted by mini-css-extract-plugin
module.exports = {"wv8ehy8":"wv8ehy8","fadeIn":"fadeIn"};